import { render, staticRenderFns } from "./Admin.html?vue&type=template&id=388f1a0e&scoped=true&external"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.scss?vue&type=style&index=0&id=388f1a0e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388f1a0e",
  null
  
)

export default component.exports